/* eslint-disable import/prefer-default-export */
import { httpGet } from '../httpCalls';
import { GetApps,GetWhiteLabelName,getWhiteLabelProNameFromSpaceId, getSpaceName,updateApps } from '../../actions/appActions';
import { GetAreas } from '../../actions/appAreasActions';
import { createSession, resetSession } from '../../actions/sessionActions';
import { resetError } from '../../actions/errorActions';

export const mapDispatchToProps = (dispatch) => ({
  resetForm: () => dispatch(resetError()),
  getApps: () => httpGet('apps').then((resp) => {
    dispatch(GetApps(resp));
    return Promise.resolve(resp);
  }),
  getWhiteLabelName:(appId)=>httpGet('apps/'+appId+'/name').then((resp)=>{
    dispatch(GetWhiteLabelName(resp));
    return Promise.resolve(resp);
  }),
  getSportRooms: (sportRoomId) => httpGet('rooms/'+sportRoomId).then((resp) => {
    dispatch(GetApps(resp));
    return Promise.resolve(resp);
  }),
  updateSessionApps: (app) => dispatch(GetApps(app)),
  getAppArea: async (id) => {
    const resp = await httpGet(`apps/${id}/areas`);
    dispatch(GetAreas(resp));
  },

  // set organization session !!! copiar lo del appmanager/kubea83)
  setAppSession: (id, reset = false) => {
    if (reset === true) {
      dispatch(resetSession());
    }
    dispatch(createSession({ appId: parseInt(id, 10) }));
  },
  setWhiteLabelNameSession: (name) => {
    if (name !== undefined) {
       dispatch(createSession({ whiteLabelName: name }));
    }
  },

      
  setOrganizationSession: (id, reset = false) => {
    if (reset === true) {
      dispatch(resetSession());
    }
    dispatch(createSession({ organizationId: parseInt(id, 10) }));
  },
  setAreaSession: (id) => {
    if (id !== undefined) {
      dispatch(createSession({ areaId: parseInt(id, 10) }));
    }
  },
  removeSession: () => dispatch(resetSession()),

  getWhiteLabelProNameFromSpaceId: (spaceId) => httpGet("rooms/"+spaceId+"/getWhiteLabelProName").then((resp) => {
      if(spaceId!==undefined){
        dispatch(getWhiteLabelProNameFromSpaceId(resp));
        return Promise.resolve(resp);
      } 
  }),
  getSpaceName:(spaceId)=>httpGet("rooms/"+spaceId+"/getName").then((resp)=>{
      if(spaceId!==undefined){
        dispatch(getSpaceName(resp));
        return Promise.resolve(resp);
      } 
  }),
  setMainHubNameSession: (name) => {
    if (name !== undefined) {
      dispatch(createSession({ mainHubName: name }));
    }
  },
  setSpaceNameSession: (name) => {
    if (name !== undefined) {
      dispatch(createSession({ spaceName: name }));
    }
  },
});
